// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"Input_inputWrapper__1TOOg","input":"Input_input__E--TV","label":"Input_label__1D8cp"};